export const HIDE_OFF_ROUTE_STATUS_BADGES_FLAG = "hide-off-route-status-badges"

type ReferenceRouteStatusBadgeVisibility = {
  isTracked: boolean
  isOffRoute: boolean
  hideOffRouteStatusBadges: boolean
}

export const shouldShowReferenceRouteStatusBadge = ({
  isTracked,
  isOffRoute,
  hideOffRouteStatusBadges,
}: ReferenceRouteStatusBadgeVisibility) =>
  isTracked && (!isOffRoute || !hideOffRouteStatusBadges)
